import { render, staticRenderFns } from "./ConsultaFichero.vue?vue&type=template&id=3b790ccf&scoped=true&"
import script from "./ConsultaFichero.vue?vue&type=script&lang=js&"
export * from "./ConsultaFichero.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaFichero.vue?vue&type=style&index=0&id=3b790ccf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b790ccf",
  null
  
)

export default component.exports